<template>
  <div class="contenedor py-0">
    <div
      class="d-flex align-items-center justify-content-center w-100"
      v-if="loading"
    >
      <LoadingSpinner></LoadingSpinner>
    </div>
    <div class="mx-2" v-else>
      <div class="d-flex justify-content-end">
        <div class="">
          <button class="btn btn-primary" @click="openPhoneModal">
            Add Phone
          </button>
        </div>
      </div>
      <hr />
      <div class="col-md-12 w-100 my-3 card p-2">
        <div class="mx-0 px-0 table-responsive">
          <div class="row">
            <Table
              class="mx-2"
              :key="keyTable"
              :headers="headers"
              :cols="cols"
              :data="phones"
              :checkbox="false"
              :notselect="true"
              :model="model"
            ></Table>
          </div>
        </div>
      </div>
    </div>

    <Modal :name="'phoneModal'" height="25%" width="50%">
      <div class="mt-2">
        <h5 class="text-center font-weight-bold">
          How many phone numbers do you want to buy?
        </h5>
        <hr class="mx-3" />
<div class="d-flex justify-content-center align-items-center mr-5">
  <div class="input-group" style="width: 100px;">
    <button
      type="button"
      @click="showFlag = true"
      class="btn btn-light py-0 my-0 px-0"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <span class="input-group-text pr-1">
        <img :src="flagActually" class="flag ml-0 mr-1" />
        <small>+ {{ country_id.phone_code }}</small>
      </span>
    </button>
    <div class="dropdown-menu dropdown-menu-left">
      <button
        v-for="(country, i) of countriesSelected.filter(
          (e) => e.visible
        )"
        class="dropdown-item"
        type="button"
        @click="changeCountry(country.id)"
        :key="i"
      >
        <img :src="flag2(country.id)" class="flag2" />
        <span class="ml-2 small"
          >+ {{ country.phone_code }} {{ country.name }}</span
        >
      </button>
      <div class="col-12 px-4 py-2">
        <span>Other country</span>
        <input
          class="my-1 border"
          placeholder="Your country..."
          type="text"
          v-model="filterCountry"
        />
      </div>
    </div>
  </div>

  <input
    type="number"
    class="form-control w-50 ml-2"
    min="1"
    max="20"
    v-model="phoneInput"
  />
</div>
        <hr class="mx-3" />
      </div>
      <div class="row mb-2">
        <div class="col-md-12 text-right">
          <button
            class="btn btn-primary mr-2"
            @click="purchaseDomainPhones"
            :disabled="phoneInput < 1 || phoneInput > 20"
          >
            {{ $t("lang.button.save") }}
          </button>
          <button class="btn btn-danger mr-3" @click="closePhoneModal">
            {{ $t("lang.button.cancel") }}
          </button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      phoneInput: 1,
      countries: [],
      countriesSelected: [],
      optionsDefault: ["ES", "IT", "US", "FR"],
      flagActually: null,
      filterCountry: null,
      showFlag: true,
      country_id: {
        id: "73",
        name: "France",
        iso: "fr",
        phone_code: "33",
        visible: true,
      },
      phones: [],
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      cols: [
        [
          {
            value: "phone",
            class: "text-left",
          },
        ],
        [
          {
            value: "created_at",
            class: "text-left",
          },
        ],
        [
          {
            value: "booker",
            class: "text-left",
          },
        ],
      ],
      headers: [
        {
          label: "Phone",
          percentage: "1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Created",
          percentage: "1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Booker",
          percentage: "10%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
      ],
    };
  },
  components: {
    Table,
    LoadingSpinner,
  },
  watch: {
    filterCountry(newValue) {
      this.countriesSelected = this.countries.map((e) => ({ ...e }));
      if (newValue.length > 2) {
        this.countriesSelected = this.countriesSelected.filter((e) =>
          e.name.toUpperCase().includes(newValue.toUpperCase())
        );
        this.countriesSelected.forEach((e) => (e.visible = true));
      }
    },
    country_id(newValue, oldValue) {
      if (newValue.id === "3333") {
        this.flagActually = null;
        return;
      }

      //if(newValue.id != "3333"){
      const flag = this.countries.find((el) => el.id === newValue.id).iso;
      this.flagActually = require("@/assets/images/flags/" + flag + ".svg");
      this.showFlag = true;
      //}
    },
  },
  computed: {
      ...mapState({
      Countries: (state) => state.optionsList.all["profile_countries"].data,
    }),
    flag2() {
      return (countryId) => {
        const flag = this.countries.find((el) => el.id === countryId).iso;
        return require("@/assets/images/flags/" + flag + ".svg");
      };
    },
  },
  created() {
    this.getData();
    this.$store.dispatch("optionsList/getProfileCountries").then(() => {
      this.countries = this.Countries.map((el) => {
        return {
          ...el,
          iso: el.iso.toLowerCase(),
          visible: this.optionsDefault.includes(el.iso),
        }
      })
      this.countriesFiltered = this.countries
      this.countryDefault()
    })
  },
  methods: {
    changeCountry(countryId) {
      this.country_id = this.countries.find((e) => e.id === countryId);
    },
    getData() {},
    openPhoneModal() {
      this.$modal.show("phoneModal");
    },
    closePhoneModal() {
      this.$modal.hide("phoneModal");
    },
    purchaseDomainPhones() {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.save"),
        text: this.$t(
          "lang.label.thisactiondoesnothaveanyincidenceoncampaignstatus"
        ),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          console.log("Purchasing phone domains...");
          this.$swal({
            type: "success",
            title: this.$t("lang.notification.success"),
            text: this.$t("lang.notification.phone_domain_purchased"),
            showCancelButton: false,
          });
          this.closePhoneModal();
        }
      });
    },
    countryDefault() {
      const flag = this.countries.find((el) => el.id == 73).iso;
      this.flagActually = require("@/assets/images/flags/" + flag + ".svg");
    },
  },
};
</script>
<style scoped>
.flag {
  width: 25px;
}
.flag2 {
  width: 12px;
}
</style>
